module.exports = __webpack_public_path__ + "f80c6e032a87dd5f4664c3454ec5b2dc.svg";